import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-bitacora-refacturacion',
  templateUrl: './bitacora-refacturacion.component.html',
  styleUrls: ['./bitacora-refacturacion.component.css']
})
export class BitacoraRefacturacionComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
